import api from '../index'

export interface DictionarySimpleOptionMap {
  [key: string]: string
}

export interface DictionaryTypeRecord {
  id: number
  name: string
  code: string
  description: string
  status: number
  is_system: boolean | number
  sort: number
  remark: string
  created_at?: string | null
  updated_at?: string | null
}

export interface DictionaryTypePagePayload {
  list: DictionaryTypeRecord[]
  total: number
  page: number
  per_page: number
}

export interface DictionaryTypeFormPayload {
  name: string
  code: string
  description: string
  status: number
  sort: number
  remark: string
}

export interface DictionaryRecord {
  id: number
  type_id: number
  code: string
  value: string
  label: string
  color: string
  icon: string
  sort: number
  status: number
  is_system: boolean | number
  remark: string
  created_at?: string | null
  updated_at?: string | null
}

export interface DictionaryPagePayload {
  list: DictionaryRecord[]
  total: number
  page: number
  per_page: number
}

export interface DictionaryFormPayload {
  type_id: number
  code: string
  value: string
  label: string
  color: string
  icon: string
  sort: number
  status: number
  remark: string
}

export interface DictionaryOptionItem {
  name: string
  value: string
}

export interface DictionaryBootstrapItem {
  value: string | number
  label: string
  color?: string
  icon?: string
}

export interface DictionaryBootstrapPayload {
  [code: string]: DictionaryBootstrapItem[]
}

export function dictionaryTypePage(params: Record<string, unknown>) {
  return api.get<unknown, { code: number, message: string, data: DictionaryTypePagePayload }>('/admin/system/config/dictionary_type', {
    params,
  })
}

export function dictionaryTypeDetail(id: number) {
  return api.get<unknown, { code: number, message: string, data: DictionaryTypeRecord }>(`/admin/system/config/dictionary_type/${id}`)
}

export function dictionaryTypeCreate(data: DictionaryTypeFormPayload) {
  return api.post('/admin/system/config/dictionary_type', data)
}

export function dictionaryTypeUpdate(id: number, data: DictionaryTypeFormPayload) {
  return api.put(`/admin/system/config/dictionary_type/${id}`, data)
}

export function dictionaryTypeDelete(id: number) {
  return api.delete(`/admin/system/config/dictionary_type/${id}`)
}

export function dictionaryTypeSimpleOptions() {
  return api.get<unknown, { code: number, message: string, data: DictionarySimpleOptionMap }>('/admin/system/config/dictionary_type/simple-options')
}

export function dictionaryPage(params: Record<string, unknown>) {
  return api.get<unknown, { code: number, message: string, data: DictionaryPagePayload }>('/admin/system/config/dictionary', {
    params,
  })
}

export function dictionaryDetail(id: number) {
  return api.get<unknown, { code: number, message: string, data: DictionaryRecord }>(`/admin/system/config/dictionary/${id}`)
}

export function dictionaryCreate(data: DictionaryFormPayload) {
  return api.post('/admin/system/config/dictionary', data)
}

export function dictionaryUpdate(id: number, data: DictionaryFormPayload) {
  return api.put(`/admin/system/config/dictionary/${id}`, data)
}

export function dictionaryDelete(id: number) {
  return api.delete(`/admin/system/config/dictionary/${id}`)
}

/**
 * 获取后台应用启动所需的聚合字典。
 */
export function dictionaryBootstrap() {
  return api.get<unknown, { code: number, message: string, data: DictionaryBootstrapPayload }>('/admin/system/config/dictionary/bootstrap')
}

export function getDictionary(code?: string) {
  return api.get<unknown, { code: number, message: string, data: Record<string, DictionaryOptionItem[]> }>('dictionary/get', {
    params: {
      code,
    },
  })
}

const apiDictionary = {
  dictionaryTypePage,
  dictionaryTypeDetail,
  dictionaryTypeCreate,
  dictionaryTypeUpdate,
  dictionaryTypeDelete,
  dictionaryTypeSimpleOptions,
  dictionaryPage,
  dictionaryDetail,
  dictionaryCreate,
  dictionaryUpdate,
  dictionaryDelete,
  dictionaryBootstrap,
  get: getDictionary,
}

export default apiDictionary
